<template>
	<div class="program">

		<table>
			<thead>
				<tr>
					<th>{{ program.title }}<!-- span v-if="!l.showLocalTimes">(CET)</!--></th>
					<th></th><!-- Second column title -->
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item) of program.items" :class="{ongoing: isCurrentItem(item)}">

					<td :class="{break: item.break}">
						{{time(convertTime(item.start),stripLeadingZeros(item.start))}}<span v-if="item.end"><br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time(convertTime(item.end),stripLeadingZeros(item.end))}}</span>
					</td>
					<td class="content">

						<div class="time" :class="{break: item.break}">{{time(convertTime(item.start),stripLeadingZeros(item.start))}}<span v-if="item.end"><br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time(convertTime(item.end),stripLeadingZeros(item.end))}}</span> </div>
						<div class="title" :class="{break: item.break}">{{ item.title }}</div>

						<div v-if="item.speaker || item.speakerKey" class="speaker">{{ item.speaker  ? item.speaker : getSpeaker(item.speakerKey).name  }} <span v-if="item.affiliation || item.speakerKey" class="affiliation">{{ item.affiliation?item.affiliation:getSpeaker(item.speakerKey).affiliation }}</span></div>
						<a v-if="item.location && item.locationUrl" class="location" :href="item.locationUrl" rel="noopener noreferrer"><span>{{ item.location }} <span class="fa fa-link"/></span></a>
						<div v-if="item.location && !item.locationUrl" class="location">{{ item.location }}</div>

						<button class="btn-details" v-if="item.details || (item.speakerKey && getSpeaker(item.speakerKey).bio)" @click="()=>{
							if (!item.show) item.show = true;
							else item.show = false;
						}"><span v-show="item.show">Hide Details <span class="icon fas fa-caret-down" /></span><span v-show="!item.show">Show Details <span class="icon fas fa-caret-right" /></span></button>
						<div class="details-container" v-if="item.show">
							<div v-if="item.speakerImage || (item.speakerKey && getSpeaker(item.speakerKey).portrait)">
								<img :src="item.speakerImage?item.speakerImage:`/data/speakers/${getSpeaker(item.speakerKey).portrait}`" class="speaker-image" />
							</div>
							<div class="details" v-html="item.details?item.details:getSpeaker(item.speakerKey).bio"/>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

	</div>
</template>


<script>


export default {
		name: "program",
		components: {
		},
		props: {
			program: {
				type: Object,
				default: {}
			},
			day: {
				type: Number,
				default: 1
			},

			speakerJson: {
				type: String,
				default: "/data/speakers.json"
			}

		},
		data: function(){

			return {
				speakers: [],
			}
		},
		created: function(){
			this.reloadJSON();
		},
		watch: {

		},
		computed: {
			currentItem: function(){
				const self = this;


				function getDate(time){
					function padTime(time){
						if (time.match(/^[0-9]:[0-9]{2}$/)){
							time = "0" + time
						}
						return time
					}
					return new Date(self.program.date + "T" + padTime(time) + self.program.UTCOffset )
				}

				function isNow(item){
					let startTime = getDate(item.start);
					let endTime = getDate(item.end);

					if (startTime <= self.g.time && endTime >= self.g.time){
						return true
					}
					return false
				}

				for (const item of self.program.items){
					if (isNow(item)){
						return item
					}

				}
			}
		},
		methods: {
			isCurrentItem: function(item){
				if (!this.currentItem) return false
				if (this.currentItem.start == item.start && this.currentItem.end == item.end){
					return true
				}
				return false
			},
			reloadJSON: async function () {
				let self = this
				if (self.speakerJson){


					// console.log("reloading Speakers");
					let response = await fetch(self.speakerJson + "?" + Date.now())
					let data = await response.json()

					self.addData("speakers")(data);
				}
			},
			addData: function (field) {
				let self = this;
				return function (data) {
					if (self.cachebreakers) {
						for (let s of data) {
							if (s.portrait != "ph.jpg") {
								s.portrait = s.portrait + "?" + Date.now();
							}
						}
					}
					self.$set(self,'speakers',data);
				};
			},
			getSpeaker: function (key){
				let self = this;
				if (!self.speakers || ! self.speakers.length) return "";
				for (const s of self.speakers) {
					if (s.key == key) {
						return s;
					}
				}
				return
			},
			convertTime(time){
				if (time.match(/^[0-9]:[0-9]{2}$/)){
					time = "0" + time
				}
				return this.program.date + "T" + time + ":00"

			},
			stripLeadingZeros(timeStr){
				if (!timeStr) return ""
				return timeStr.replace(/^0/,"")
			},
			openModal(item){
				item.time = this.convertTime(item.start)
				this.g.videomodal.openModal(item)
			},
			getSlides(item){
				item.time = this.convertTime(item.start)
				this.g.slidemodal.openModal(item)
			},

		},


	}


</script>

<style lang="less" >

	@keyframes pulseBackground {
		0% {background-color: rgba(220,220,220,0.2);}
		50% {background-color: rgba(240,240,240,0.4);}
		100% {background-color: rgba(220,220,220,0.2);}

	}

	.program {

		button.btn-details{

			display: inline-block;

			margin-top: 1em;

			background-color: transparent;
			border: 1px solid #b0b0b0;
			border-radius: 0.4em;
			padding: 0.3em 0.5em;
			cursor: pointer;
			transition: background-color 0.3s;
			font-size: 0.9em;
			&:hover{
				background-color: #f0f0f020;
			}
			.icon{
				display: inline-block;
				margin-left: 0.5em;
			}
		}

		table {
			padding: 5px;
			font-size: 1.3em;
			overflow-x: auto;

			thead {
				tr {
					font-weight: bold;
					font-size: 1.1em;
					border-bottom: 2px solid gray;
					background-color: rgba(220,220,220,0.2);
					border-top-left-radius: 0.15em;
					border-top-right-radius: 0.15em;
				}
			}

			tr {
				th {
					padding: 0.5em 1em;
				}
				td {
					padding: 1em 1em;
					text-align: left;
				}
				td:nth-child(1), th:nth-child(1){
					text-align: center;
					width: 10em;
					vertical-align: top;
					@media screen and (max-width: 800px) {
						display: none;
					}
				}
			}


			tbody {
				tr:not(:last-child){
					border-bottom: 2px solid rgba(193, 185, 201,0.8);
					min-width: 30em;
					padding-right: 1em;
					// padding-bottom: 1em;
					// padding-top: 0.5em;
				}

				tr.ongoing {
					background-color: rgba(220,220,220,0.2);


					.content::before{
						background-color: rgba(220,220,220,0.2);
						animation: 4s pulseBackground ease-in-out infinite;

						content: "ongoing";
						display: block;

						font-size: 1em;
						font-weight: bold;
						padding: 0.2em 0.7em;
						margin-bottom: 0.5em;
						width: fit-content;
						border-radius: 0.5em;
					}

				}

				.content {
					a.ongoing {
						position: absolute;
						margin-top: -10em;
						visibility: hidden;
						// display: none;
					}
					.time {
						@media screen and (min-width: 801px) {
							display: none;
						}
						font-weight: bold;
						margin-bottom: 0.5em;
					}

					font-size: 0.9em;
					.speaker {
						color: #18BCA1;
						padding: 0.5em 0;
						.affiliation {
							@media screen and (max-width: 800px) {
								display: block;
								font-style: italic

							}


							@media screen and (min-width: 801px){
								display: inline-block;
								&:before {
									content: " - ";
								}
								font-style: normal;
							}

						}
					}

					.title{
						font-weight: bold;
					}
					.title.break {
						font-weight: normal;
					}
					.title + .location{
						margin-top: 1em;
						margin-bottom: 0.5em;
					}

					.location{
						font-style: italic;
						font-size: 0.9em;
						border-radius: 0.8em;
						padding: 0.2em 0.8em;
						width: fit-content;
						background-color: rgba(220,220,220,0.1);
					}
					a.location{
						display: block;
						color: white !important;
						text-decoration: none !important;

						border-bottom: none !important;
						&:focus, &:active, &:visited {
							border-bottom: none !important;
						}
						&:hover {
							background-color: rgba(220,220,220,0.2)
						}
						.fa {
							display: inline-block;
							margin-left: 0.5em;
						}

					}

					.details-container {
						display: flex;
						gap: 1em;
						@media screen and (max-width: 1000px) {
							flex-direction: column;
						}
						margin-top: 1em;
						padding: 1em;
						border: 1px solid white;
						background-color: #f0f0f005;
						box-shadow: 0 0 10px rgba(0,0,0,0.2);
						background-color: white;
						border-radius: 0.5em;

						font-size: 1.3rem ;
						p {
							color: #666 !important;
							font-size: 1.15em;
							line-height: 1.3 ;
							font-weight: 100;
							&:last-of-type{
								margin-bottom: 0;
							}

						}
						img {
							border-radius: 0.5em;


						}
					}
				}
			}
		}
	}
</style>
